import type { ReactNode } from "react";
import TrendBadge from "@/components/base/TrendBadge";

interface StatTrend {
  value: number;
  direction: "up" | "down" | "flat";
  suffix?: string;
  tone?: "auto" | "neutral";
}

interface StatCardProps {
  label: string;
  icon: string;
  iconClass?: string;
  children: ReactNode;
  caption?: string;
  trend?: StatTrend;
}

export default function StatCard({
  label,
  icon,
  iconClass = "bg-primary-100 text-primary-700",
  children,
  caption,
  trend,
}: StatCardProps) {
  return (
    <div className="yc-fade-up yc-card-hover flex flex-col bg-white rounded-card border border-background-200 shadow-card p-5">
      <div className="flex items-start justify-between">
        <div className="min-w-0">
          <p className="text-sm text-foreground-500">{label}</p>
          {children}
        </div>
        <span
          className={`w-12 h-12 shrink-0 flex items-center justify-center rounded-full text-xl ${iconClass}`}
        >
          <i className={icon}></i>
        </span>
      </div>

      {(caption || trend) && (
        <div className="mt-auto flex items-center justify-between gap-2 border-t border-background-100 pt-3">
          {caption && (
            <span className="text-[11px] text-foreground-400">{caption}</span>
          )}
          {trend && (
            <TrendBadge
              value={trend.value}
              direction={trend.direction}
              suffix={trend.suffix}
              tone={trend.tone}
            />
          )}
        </div>
      )}
    </div>
  );
}